/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { getQueryParameterFromUrl } from "dc-preview-utils/src/Utils/UrlUtils";
import docApi from "api";
import { lhpFeatures, pageViewModifiers } from "constants/enums";

let eventMetrics = {};

export const resetEventMetrics = () => (eventMetrics = {});

export const isTelemetryEnabled = () => getQueryParameterFromUrl(window.location.href, "enableTelemetry") === "true";

export const recordEventStartMetrics = (command, data) => {
  if (!(command in eventMetrics)) {
    eventMetrics[command] = [];
  }
  if (command === "isOverText") {
    // Do nothing
  } else {
    eventMetrics[command].push(data);
  }
};

export const recordEventEndMetrics = (command, data) => {
  console.info(eventMetrics[command]);
  if (eventMetrics[command]) {
    let length = eventMetrics[command].length;
    for (let i = 0; i < length; i++) {
      if (eventMetrics[command][i].msgId === data.msgId) {
        eventMetrics[command][i].end = data.end;
        eventMetrics[command][i].error = data.error;
        console.log(`${command}:${JSON.stringify(eventMetrics[command][i])}`);
        break;
      }
    }
  }
};

export const getFileSizeBytes = metadata => {
  // helper function to get the file size
  // either from metadata or from docApi
  const { size, buffer } = metadata;
  if (size) return Promise.resolve(size);
  else if (buffer) return Promise.resolve(buffer.byteLength);
  return docApi.getFileBuffer().then(buffer => buffer.byteLength);
};

export const lhpFeatureToString = lhpFeature => {
  switch (lhpFeature) {
    case lhpFeatures.THUMBNAIL:
      return "Thumbnails";
    case lhpFeatures.BOOKMARKS:
      return "Bookmark";
    case lhpFeatures.ATTACHMENTS:
      return "Attachment";
  }
};

export const viewModifierToString = viewModifier => {
  switch (viewModifier) {
    case pageViewModifiers.FIT_PAGE:
      return "Fit Page";
    case pageViewModifiers.FIT_WIDTH:
      return "Fit Width";
    case pageViewModifiers.FIXED_WIDTH:
      return "Fixed Width";
    case pageViewModifiers.FIT_HEIGHT:
      return "Fit Height";
  }
};
